<template>
  <v-card max-height="480" height="480">
    <v-toolbar dark :color="color">
      <v-toolbar-title class="title"
        ><img v-if="image" :src="image" alt="" />{{ title }}
      </v-toolbar-title>
      <v-spacer> </v-spacer>
      <v-chip color="accent">
        <v-icon>mdi-counter</v-icon>
        : {{ total }}
      </v-chip>
    </v-toolbar>
    <v-card-text v-if="total > 0">
      <!-- Chart -->
      <apexchart
        v-if="loaded"
        type="pie"
        width="100%"
        height="400"
        :options="chartOptions"
        :series="series"
      ></apexchart>
      <v-skeleton-loader
        v-else
        class="mx-auto"
        type="image"
      ></v-skeleton-loader>
    </v-card-text>
    <v-card-text v-else> No Data </v-card-text>
  </v-card>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  data() {
    return {
      chartOptions: null,
      series: [],
      loaded: false,
      total: 0,
    };
  },
  props: {
    agentEmail: {
      type: String,
    },
    color: {
      type: String,
      default: "primary",
    },
    title: {
      type: String,
      default: "Your Current Cases",
    },
    image: {
      type: String,
      default: null,
    },
    refreshInterval: {
      type: Number,
      default: 5000,
    },
  },
  mounted() {
    this.getChartData();
    // refresh every 5 seconds
    setInterval(() => {
      this.getChartData();
    }, 5000);
  },
  methods: {
    getChartData() {
      let that = this;
      axios
        .get(`/api/v1/bot-home/active/${that.agentEmail}`)
        .then((response) => {
          // Stacked chart data
          let series = [];
          let labels = [];
          let total = 0;
          let colors = [];
          response.data.forEach((element) => {
            total += Math.round(element.status_count);
          });
          this.total = total;
          response.data.forEach((element) => {
            labels.push(element.status);
            series.push((Math.round(element.status_count) / total) * 100);
            colors.push(that.getColor(element.status));
          });
          that.series = series;
          that.chartOptions = {
            colors: colors,
            chart: {
              type: "pie",
              height: 400,
            },
            labels: labels,
            tooltip: {
              theme: "dark",
              y: {
                formatter: function (value) {
                  return Math.round((value * total) / 100);
                },
              },
            },
            dataLabels: {
              enabled: false,
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
          };
          that.loaded = true;
        });
    },
    getColor(status) {
      switch (status) {
        case "Open":
          return "#f53131";
        case "Solved":
          return "#969696";
        case "Pending":
          return "#1db0e0";
        case "On-hold":
          return "#4a4a4a";
        default:
          return "#9234eb";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  gap: 10px;
  img {
    height: 30px;
    width: 30px;
    border-radius: 50%;
  }
}
</style>
